module.exports = __webpack_public_path__ + "img/ticket_p.77336723.svg";